const INITIATED = 'initiated';
const RINGING = 'ringing';
const IN_PROGRESS = 'in-progress';
const COMPLETED = 'completed';
const ENDING = 'ending';
const ENDED_BY_MANAGER = 'ended-by-manager';
const FAILED = 'failed';
const NO_ANSWER = 'no-answer';
const CANCELED = 'canceled';

module.exports = {
    INITIATED,
    RINGING,
    IN_PROGRESS,
    COMPLETED,
    ENDING,
    ENDED_BY_MANAGER,
    FAILED,
    NO_ANSWER,
    CANCELED
}